levels.FPS = {
    run: function (episode, level) {
        if (!levels.FPS.fpsInterval) {
            levels.FPS.episode = episode;
            levels.FPS.level = level;
            levels.FPS.fpsStatistics = [];
            levels.FPS.fpsTotalFrames = cc.director.getTotalFrames();
            levels.FPS.fpsInterval = cleverapps.timeouts.setInterval(() => {
                if (levels.FPS.fpsStatistics.length < levels.FPS.FPS_STATISTICS_MAX_LENGTH) {
                    const tf = cc.director.getTotalFrames();
                    let fps = Math.round((tf - levels.FPS.fpsTotalFrames) * 1000 / levels.FPS.FPS_STATISTICS_INTERVAL);
                    if (fps > 60) {
                        fps = 60;
                    } 
                    levels.FPS.fpsStatistics.push(fps);
                    levels.FPS.fpsTotalFrames = tf;
                } else {
                    levels.FPS.stop();
                }
            }, levels.FPS.FPS_STATISTICS_INTERVAL);
        }
    },

    stop: function () {
        if (levels.FPS.fpsInterval) {
            cleverapps.timeouts.clearInterval(levels.FPS.fpsInterval);
            levels.FPS.fpsInterval = false;
        }
        if (levels.FPS.fpsStatistics && levels.FPS.fpsStatistics.length) {
            levels.FPS.fpsStatistics.sort();
            const percentFps = levels.FPS.fpsStatistics[Math.floor(levels.FPS.fpsStatistics.length * levels.FPS.FPS_STATISTICS_PERCENT_VALUE)];
            console.log(`SAVE FPS: ${percentFps}`);

            cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.FPS_RATE, { value: percentFps });
            levels.FPS.fpsStatistics = false;
        }
    }
};

levels.FPS.FPS_STATISTICS_MAX_LENGTH = 15;
levels.FPS.FPS_STATISTICS_PERCENT_VALUE = 0.1;
levels.FPS.FPS_STATISTICS_INTERVAL = 500;
levels.FPS.FPS_SWITCH_TO_LOW = 40;